<template>
    <div>
        <b-table 
            id="channels-table"
            :readonly="isBusy"
            :items="channels"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
        >
            <template slot="logo_url" slot-scope="data">
                <img :src="data.item.image_url" :width="64">
            </template>
            <template slot="categories" slot-scope="data">
                <b-badge class="mr-1" v-for="pack in data.item.categories" :key="pack.id">{{pack.name}}</b-badge>
            </template>
        </b-table>
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"></b-pagination>

    </div>
</template>
<script>
    import Vue from 'vue'

    export default {
        name: 'ChannelListForm',
        props: ['model','type'],
        components: {  },

        data () {
            return {
                isBusy: false,
                channels: [],
                fields:[
                    { key: "id", sortable: true },
                    { key: "logo_url", sortable: false },
                    { key: "name", sortable: true, thStyle: "width:50%;" },
                    { key: "categories", sortable: false }
                ],
                perPage: 100,
                currentPage: 1,
                totalRows: 0,
            }
        },
        created: function () {},
        mounted: function () {},
        watch: {
            model:
            {
                handler: function () {
                    if(this.model.id) {
                        let promise = this.$noname.getChild(this.type, this.model.id, 'channels', {params:{perPage:100}});
                        return promise.then((data) => {
                            this.channels = data.data.items
                            this.$root.$emit('bv::refresh::table', 'channels-table');
                        }).catch(this.$noname.HandleError)
                    }
                },
                deep: true
            },
        },
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/modules/ChannelListForm.vue